export default __webpack_public_path__ + "locales/si/Webhooks.json?hash=c8ff42c0064f7310af43ccd765971f8c";